package com.ives.components.thumb;

import com.er453r.hxcompo.Component;

import com.ives.components.browse.DicomBrowse;
import com.ives.utils.Remoting;
import com.ives.utils.Config;

class DicomThumb extends Component {
	public var dicomImageData(default, null):DicomImageData;

	public function new(id:String) {
		Remoting.getDicomImageData(DicomBrowse.currentSource, id, onDicomImageData);

		on(thumbnail, "click", onClick);
	}

	private function onClick(){
		dispatch("studySelected", dicomImageData);
	}

	private function onDicomImageData(dicomImageData:DicomImageData){
		this.dicomImageData = dicomImageData;

		if(dicomImageData.photometricInterpretation.length < 1){
			image.src = 'assets/no-image.png';

			return;
		}

		if(dicomImageData.numberOfFrames == 0)
			image.src = '${Config.SERVER_URL}/dicom/${DicomBrowse.currentSource}/thumbnail/${dicomImageData.childIds[Math.floor(dicomImageData.childIds.length / 2)]}/0';
		else
			image.src = '${Config.SERVER_URL}/dicom/${DicomBrowse.currentSource}/thumbnail/${dicomImageData.childIds[0]}/${Math.floor(dicomImageData.numberOfFrames / 2)}';
	}
}
